import * as types from '../const/action.types';
import { get, post, put } from '../api/_basic';

export function loadTemplates() {
    return async (dispatch) => {
        dispatch(TemplateHasErrored(false, ''));
        dispatch(TemplatesIsLoading(true));
        return get(`${process.env.REACT_APP_API_TEMPLATE}`)
            .then((response) => {
                dispatch(TemplatesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(TemplateHasErrored(false, ''));
                dispatch(loadTemplatesSuccess(items));
            })
            .catch((error) => {
                dispatch(TemplatesIsLoading(false));
                dispatch(TemplateHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addTemplate(template) {
    return async (dispatch) => {
        dispatch(TemplateIsSaving(true));
        return post(`${process.env.REACT_APP_API_TEMPLATE}`, template)
            .then((response) => {
                dispatch(TemplateIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function editTemplate(template) {
    return async (dispatch) => {
        dispatch(TemplateIsSaving(true));
        return put(`${process.env.REACT_APP_API_TEMPLATE}/${template.id}`, template)
            .then((response) => {
                dispatch(TemplateIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadTemplate(id) {
    return async function(dispatch) {
        dispatch(TemplateHasErrored(false, ''));
        dispatch(loadTemplateSuccess({}));
        return get(`${process.env.REACT_APP_API_TEMPLATE}/${id}`)
            .then((response) => {
                dispatch(TemplateHasErrored(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(TemplateHasErrored(false, ''));
                dispatch(loadTemplateSuccess(item));
            })
            .catch((error) => {
                //throw error;
                dispatch(TemplateHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadTemplatesSuccess(data) {
    return {
        type: types.LOAD_TEMPLATES_SUCCESS,
        data,
    };
}

export function loadTemplateSuccess(data) {
    return {
        type: types.TEMPLATE_SUCCESS,
        data,
    };
}

export function TemplateHasErrored(bool, message) {
    return {
        type: types.TEMPLATE_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function TemplatesIsLoading(bool) {
    return {
        type: types.TEMPLATES_IS_LOADING,
        isLoading: bool,
    };
}

export function TemplateIsSaving(bool) {
    return {
        type: types.TEMPLATE_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/templates.actions.js